<template>
  <div class="phrase-overlay" :style="visible ? 'z-index:300010' : 'z-index:-30000; opacity:0'">
    <transition name="fade">
      <div class="export-dialog list-export-dialog" v-if="visible" style="max-width: 520px">
        <div class="newmessage-title">
          <span>紹介スライド設定</span>
          <div class="flex-space"></div>
          <div class="newmessage-button" @click="close()">
            <font-awesome-icon :icon="['fal', 'times']" />
          </div>
        </div>
        <div class="export-dialog-box">
          <div class="export-subtitle">インフルエンサー</div>
          <div style="font-size: 13px; line-height: 1.6; margin-bottom: 16px">{{ influencerDisplayText }}</div>
          <div style="font-size: 14px; line-height: 1.8">
            <div>紹介スライド作成を受け付けました。</div>
            <div>通常、数分以内に完了します。</div>
            <div style="margin-top: 12px">
              完了後、
              <router-link
                :to="{ path: '/list', query: { tab: 'bio_slide_history' } }"
                class="router-link bio-slide-history-link"
                @click.native="close()"
              >
                <font-awesome-icon :icon="['fas', 'file-alt']" style="margin-right: 4px" />
                紹介スライド出力履歴
              </router-link>
              からご確認ください。
            </div>
          </div>
        </div>
        <div class="list-create-footer">
          <div class="flex-space"></div>
          <el-button type="primary" @click="close()">閉じる</el-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "influencerBioSlideCompleteModal",
  props: {
    visible: { type: Boolean, default: false },
    checkListDetail: { type: Array, default: () => [] },
  },
  computed: {
    influencerDisplayText() {
      const names = this.checkListDetail.map((d) => d.account_name).filter(Boolean);
      if (names.length === 0) return "";
      if (names.length <= 3) return names.join("、");
      return `${names.slice(0, 2).join("、")}、他${names.length - 2}名`;
    },
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped>
.bio-slide-history-link {
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 2px;
}
</style>
